import { render, staticRenderFns } from "./Project10.vue?vue&type=template&id=e5bd115a&scoped=true&"
import script from "./Project10.vue?vue&type=script&lang=js&"
export * from "./Project10.vue?vue&type=script&lang=js&"
import style0 from "./Project10.vue?vue&type=style&index=0&id=e5bd115a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bd115a",
  null
  
)

export default component.exports